import type { IconData } from '@stacksjs/iconify-core'

export const poundCircle: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3\"/><path d=\"M24 8c8.837 0 16 7.163 16 16s-7.163 16-16 16S8 32.837 8 24S15.163 8 24 8\"/><path d=\"M29.5 15.885s-4.5-2.337-7 .584C19.186 20.341 24 28.49 18 30.827c0 0 6.667.39 12 0m-2-7.179H18\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default poundCircle
